import { SVGProps } from 'react'

const MessageCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width || '22'}
      height={props.height || '22'}
      fill='none'
      viewBox='0 0 22 22'
      {...props}
    >
      <path
        fill='#1D1D1F'
        fillRule='evenodd'
        d='M10.996 19.243a8.256 8.256 0 0 1-7.977-6.148 8.26 8.26 0 0 1 3.897-9.288 8.255 8.255 0 0 1 12.282 6.182 8.26 8.26 0 0 1-1.093 5.206 1.4 1.4 0 0 0-.137 1.082l.69 2.341-2.362-.674a1.37 1.37 0 0 0-1.082.138 8.23 8.23 0 0 1-4.216 1.16zm9.252 2.7a1.376 1.376 0 0 0 1.7-1.7c-.137-.48-1.192-4.162-1.191-4.174a11 11 0 0 0-3.263-13.944A10.995 10.995 0 0 0 .032 10.161a11 11 0 0 0 8.464 11.55c2.557.598 5.243.26 7.573-.95l4.179 1.185z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default MessageCircle
